const ja = {
    menu: {
        home: "ホーム",
        new_game: "ニューゲーム",
        game_new: "新着ゲーム",
        favorite_game: "おすすめ",
        favorite: "おすすめ",
        slot: "スロット",
        live_casino: "ライブカジノ",
        live: "ライブ",
        promotions: "プロモーション",
        contact_us: "お問い合わせ",
        supplier: "一覧",
        all_providers: "すべてのプロバイダー",
        english: "English",
        japanese: "日本語"
    },

    common: {
        user_name: 'ユーザー名',
        pass_word: 'ログインパスワード',
        login: "ログイン",
        sign_out: "ログアウト",
        search_games: "ゲームを探す",
        load_more: "さらに読み込む",
        loading: "読込中",
        loading_game: "ゲームの読込中",
        level: "レベル",
        balance: "残高",
        play_now: "今すぐプレイ",
        play_game: "ゲームを開始",
        game_name: "ゲーム名",
        play_for_real: "リアルゲーム",
        user_name_place_holder: "ユーザー名は6 ~ 16ビットです",
        password_place_holder: "6 ~ 16桁のログインパスワードを入力します",
        remember_password: "パスワードに記憶させる",
        logging_in: "ログイン中..."
    },

    game: {
        gems_bonanza: "ボーナスゲーム",
        game_demo: "デモゲーム",
    },

    message: {
        invalid_credentials: "承認情報が無効です",
        validation_failed: "承認に失敗しました",
        no_games_found: "ゲームが見つかりません",
        error_update_user: "更新中にデータエラー発生",
        error_fetch_balance: "残高取得エラー",
    },
};

export default ja;
